<template>
    <div class=" max-h-44 overflow-y-scroll overscroll-none flex flex-col">
        <div v-for="step in missingSteps" :key="step.id" class="m-1 border-b last:border-b-0 whitespace-nowrap p-1">
            {{ step.step_name }}
        </div>
    </div>
</template>

<script setup>
import { defineProps, computed } from 'vue';

const props = defineProps(['person', 'workflowSteps'])

const missingSteps = computed(() => {
    const userWorkflowSteps = props.person.workflow_steps.filter(workflowStep => workflowStep.completed_on).map(workflowStep => workflowStep.workflow_step.id)
    return props.workflowSteps.filter((step) => {
        return !userWorkflowSteps.includes(step.id)
    })
})

</script>